module.exports = __webpack_public_path__ + "img/hk_nobo.c9d7484a.png";